import React, { Dispatch, SetStateAction } from "react";

import { IMetaParameter, INocCode } from "../../interfaces/services";
import { IParametersData } from "../../interfaces/forms";
import { ISelectDropdownOption } from "../../interfaces/form_elements";

import { BooleanOptions, SearchableMultiSelect, TextInput } from "../reusables/TableInputs";
import { SVGIcon } from "../wrappers/SVGIcon";

import { Icons } from "../../data/Assets";

interface IParametersTableProps {
    parameters: IParametersData[];
    setParameters: Dispatch<SetStateAction<IParametersData[]>>;
    metaParameters: IMetaParameter[];
    nocCodes: INocCode[];
};
const ParametersTable = (props: IParametersTableProps) => {
    const { parameters, setParameters, metaParameters, nocCodes } = props;

    const onTextChange = (name: string, value: string) => {
        setParameters(prevData => {
            const newData = [...prevData];

            if (!value.length) {
                const index = newData.findIndex(p => p.name === name);
                if (index !== -1) {
                    newData.splice(index, 1);
                };
                return newData;
            };

            const existingParamIdx = newData.findIndex(p => p.name === name);
            if (existingParamIdx !== -1) {
                if (!value.length) {
                    newData.splice(existingParamIdx, 1);
                } else {
                    newData[existingParamIdx].value = value;
                };
            } else {
                newData.push({ id: null, name, value });
            };
            return newData;
        });
    };

    const onRemoveParam = (name: string) => {
        setParameters(prevData => {
            const newData = [...prevData];
            const index = newData.findIndex(p => p.name === name);
            if (index !== -1) {
                newData.splice(index, 1);
            };
            return newData;
        });
    };

    return (
        <div className="immployer_admin__table_container__wrapper">
            <div className="immployer_admin__table_container">
                <table className="immployer_admin__table">
                    <thead>
                        <tr>
                            <th>Parameter</th>
                            <th>Value</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            !metaParameters?.length
                                ? <tr><td colSpan={3}>Loading...</td></tr>
                                : metaParameters.map((param, index) => {
                                    const dbParam = parameters.find(p => p.name === param.name);
                                    const options: ISelectDropdownOption[] = param.type === 'list' ? nocCodes?.map(n => ({ value: n.noc_code, label: n.noc_code })) : [];

                                    return (
                                        <tr key={index}>
                                            <td>{param.name}</td>
                                            <td className="immployer_admin__input_cell min_wdth_40 max_wdth_40">
                                                {
                                                    param.type === 'int'
                                                        ? <TextInput
                                                            name={param.name}
                                                            value={dbParam?.value ?? ''}
                                                            onChange={(value) => onTextChange(param.name, value)}
                                                            placeholder="Enter value"
                                                            pattern_mask="integer"
                                                            max_length={7}
                                                        />
                                                        : param.type === 'list'
                                                            ? <SearchableMultiSelect
                                                                name={param.name}
                                                                values={dbParam?.value ? JSON.parse(dbParam.value) : []}
                                                                setValues={values => onTextChange(param.name, JSON.stringify(values))}
                                                                placeholder="Enter value"
                                                                options={options}
                                                            />
                                                            : param.type === 'boolean'
                                                                ? <BooleanOptions
                                                                    name={param.name}
                                                                    value={dbParam?.value ?? ''}
                                                                    onChange={(value) => onTextChange(param.name, value)}
                                                                />
                                                                : ''
                                                }
                                            </td>
                                            <td>
                                                <button
                                                    onClick={() => dbParam?.value ? onRemoveParam(param.name) : null}
                                                    className={`immployer_admin__table_cell_delete_btn ${!dbParam?.value ? 'immployer_admin__table_cell_delete_btn__disabled' : ''}`}
                                                >
                                                    <SVGIcon src={Icons.Trash2Fill} color={dbParam?.value ? 'error' : 'grey'} />
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ParametersTable;